"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var FilterPill = function FilterPill(_ref) {
  var name = _ref.name,
      count = _ref.count,
      isDismissable = _ref.isDismissable,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  return (0, _preact.h)("li", {
    className: "filter-list-pill"
  }, (0, _preact.h)("span", null, name), count && (0, _preact.h)("span", {
    className: "filter-count"
  }, " ", count, " "), isDismissable && (0, _preact.h)(_Close.default, {
    onClick: onClick,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        onClick();
        e.preventDefault();
      }
    },
    width: 16,
    height: 16,
    fill: "#fff",
    role: "button",
    "aria-label": "Remove filter",
    "aria-hidden": "false",
    focusable: "true",
    tabIndex: 0
  }));
};

var _default = FilterPill;
exports.default = _default;